import React, { useState ,useEffect} from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { showToast } from "../constants/Toaster";
import { createCity } from "../../services/apiServices/PostServices";
import { set } from "react-hook-form";

const FaqModal = ({ open, close, addFAQ,data ,dataEdit,edit,statusChecked,option,stateIdValue,from}) => {
  const [question,setQuestion] = useState("")
  const [answer,setAnswer] = useState("")
  const [cityName,setCityName]=useState("")
  const history = useHistory();

  const createCityBody = {
      state_id : stateIdValue,
      name : cityName
  }

   

  //function to to set predifned question and answer
  useEffect(() => {
    if(data === undefined || data === ""){
      setQuestion("")
      setAnswer("")
      
    }else{
      setQuestion(data?.question)
      setAnswer(data?.answer)
    }
}, [data]);



  //function to handle on change question
  const handleOnQuestion = (e) => {
   let questionValue = e.target.value;
   if (questionValue.length === 1 && questionValue[0] === ' ') {
    // setInputValue(newInputValue);
    setQuestion("");
  }else{
    setQuestion(questionValue)
  }
   
  };

  const handleCreateCity = (e) => {

    const newInputValue = e.target.value;

    // Check if the input contains only alphabetic characters
    if (/^[a-zA-Z][a-zA-Z\s]*$/.test(newInputValue) || newInputValue === '') {
      setCityName(newInputValue)
    }
    
  }

  //function to handle on change answer
  const  handleAnswer = (e) => {
    let answerValue  =e.target.value 
  
          if (answerValue.length === 1 && answerValue[0] === ' ') {
            // setInputValue(newInputValue);
            setAnswer("");
          }else{
            setAnswer(answerValue)
          }
   
  }

  const reqbody = {
    question: question ,
    answer:  answer 
  }

  const editReqBody = {
    id:data?.id,
   question:question,
    answer:answer,
    status:statusChecked !== "" ? statusChecked : data?.status
  }

  // Define functions to handle interactions or actions within the modal
  const handleSaveChanges = () => {
    if(question === "" || answer === ""){
      showToast(3,"Please enter question and answer fields")
    }else{
      addFAQ(reqbody)
      setQuestion("")
      setAnswer("")
       close();
    }
  };

  const handleAddCity = async () => {
    if(cityName.length < 3){
      showToast(3,"Please enter minimum 3 characters")
    }else
    { 
      try{
        const res = await createCity("city",createCityBody) 
        if(res?.success){
          showToast(1,res?.message)
          setCityName("")
          close()
        }else{
          showToast(3,res?.message)
          console.log("res",res?.message)
        }
      }catch(error){
        console.log("error",error)
      }
     
    }
   

    
  }

  //function call to handle edit action of the modal
  const handleEditChange = () => {
    if(question === "" || answer === ""){
      showToast(3,"Please enter question and answer fields")
    }else{
       edit(editReqBody)
        close();
    }
  }

  const handleCloseModal = () => {
    // Handle closing the modal
    setQuestion("")
    setAnswer("")
    setCityName("")
    close();
  };

  return (
    <Modal show={open} onHide={handleCloseModal}  centered size={"md"} backdrop="static" >

      {
        option ==="addCity" ? 
        <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white"}} data-bs-theme="dark" closeButton>
        <h6 class="text-white fw-bold m-0 montserrat">{"Add City"}</h6>
      </Modal.Header> :
      <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white"}} data-bs-theme="dark" closeButton>
      <h6 class="text-white fw-bold m-0 montserrat">{dataEdit !== "" ? dataEdit === "Edit" ? "Edit" : "View" : "Add FAQs Question And Answer"}</h6>
    </Modal.Header>
      }
     
      {
        option ==="addCity" ? 
        <Modal.Body class="text-center p-4">
        <div class="">
        <div class="mb-4" >
            <input class="form-control form-control-lg" type="text" name="City" placeholder="Enter City Name" value={cityName} aria-label="default input example" onChange={handleCreateCity}></input>
        </div>
       
        <div class="d-flex flex-row my-1 mb-2 w-25  ">
          <button class="primaryButton px-2 me-3  " onClick={handleAddCity}>{"Add"}</button>      
        </div>
        </div>
      </Modal.Body>
      :
      <Modal.Body class="text-center p-4 pb-0">
        <div class="">
        <div class="mb-4" >
            <input class="form-control form-control-lg" type="text" name="question" placeholder="Question" value={ question} aria-label="default input example" onChange={(e) => {handleOnQuestion(e)}}></input>
        </div>
        <div class="mb-4" >
            <textarea class="form-control form-control-lg" name="answer" id="exampleFormControlTextarea1" placeholder="Answer" rows="5" value={answer}
            onChange={(e) => { handleAnswer(e)}}></textarea>
        </div>
        <div class="d-flex flex-row justify-content-center my-1 mb-2  ">
          <button class="primaryButton w-25    " onClick={ dataEdit ? handleEditChange : handleSaveChanges}>{dataEdit ? "Save" :"Add"}</button>      
        </div>
        </div>
      </Modal.Body>

      }
      
    </Modal>
  );
};

export default FaqModal;
